import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as Data from "@/data";
import date from 'quasar/src/utils/date.js';;
import * as Helpers from "../../helpers";
import ResyndicationHistoryTable from "@/components/property/ResyndicationHistoryTable";
export default {
  components: {
    ResyndicationHistoryTable: ResyndicationHistoryTable
  },
  props: {
    propertyId: {},
    addLabel: {},
    federalTypes: {},
    showEUP: {
      default: false
    },
    showPIS: {
      default: false
    },
    showManagementFee: {
      default: false
    },
    managementFeeYear: {}
  },
  data: function data() {
    return {
      date: date,
      federalTypesValues: [],
      info: null,
      propertyStatusOptions: Helpers.ProjectHelper.GetStatusArray(),
      managementFee: 0
    };
  },
  computed: {
    cardStyle: function cardStyle() {
      if (!this.info.nonCompliant) return "sticky-top no-shadow q-pt-none q-pb-none text-white bg-primary";else return "sticky-top no-shadow q-pt-none q-pb-none text-white bg-red";
    },
    statusLabel: function statusLabel() {
      var _this = this;

      if (this.info.status == 5 && this.info.decontrolStatus != 5) return "Decontrol: Pending";
      if (this.info.status > 0 && this.propertyStatusOptions.some(function (x) {
        return x.value == _this.info.status;
      })) return this.propertyStatusOptions.find(function (x) {
        return x.value == _this.info.status;
      }).label;
      return "";
    }
  },
  mounted: function mounted() {
    this.loadPropertyInfo();
    if (this.showManagementFee) this.loadManagementFee();
  },
  methods: {
    loadPropertyInfo: function () {
      var _loadPropertyInfo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.propertyId || this.propertyId == 0)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return Data.Projects.GetProjectInformation(this.propertyId);

              case 4:
                this.info = _context.sent.data;

                if (!this.federalTypes) {
                  _context.next = 9;
                  break;
                }

                _context.next = 8;
                return Data.Projects.GetFederalTypes(this.propertyId);

              case 8:
                this.federalTypesValues = _context.sent.data;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadPropertyInfo() {
        return _loadPropertyInfo.apply(this, arguments);
      }

      return loadPropertyInfo;
    }(),
    loadManagementFee: function () {
      var _loadManagementFee = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Data.ManagementFeeMax.GetUsedMgmtFee(this.propertyId, this.managementFeeYear);

              case 2:
                this.managementFee = _context2.sent.data;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadManagementFee() {
        return _loadManagementFee.apply(this, arguments);
      }

      return loadManagementFee;
    }(),
    click: function click() {
      if (this.isAdmin) {
        var routeData = this.$router.resolve("/editproject/".concat(this.propertyId));
        window.open(routeData.href, "_blank");
      }
    },
    openResyndicationDialog: function openResyndicationDialog(latest) {
      this.$q.dialog({
        component: ResyndicationHistoryTable,
        parent: this,
        propertyId: this.propertyId,
        latest: latest,
        persistent: false
      });
    }
  },
  watch: {
    propertyId: function propertyId() {
      this.loadPropertyInfo();
    }
  }
};